import { Types } from '@amplitude/unified';

/**
 * Метка платформы, которую получает каждое событие. Мобильные приложения пишут в это же
 * свойство `ios` / `android`, поэтому имя ключа — общий контракт с мобильной командой,
 * а не деталь веба: меняется только вместе с ней.
 */
export const APP_PLATFORM_PROPERTY = 'app_platform';

export const APP_PLATFORM_WEB = 'web';

/**
 * Свойство называется `app_platform`, а не `platform`, потому что `platform` — встроенное
 * поле события Amplitude (`Web` у браузерного SDK, `iOS` / `Android` у мобильных). Своё
 * свойство с тем же именем встало бы в интерфейсе Amplitude рядом со встроенным и путало бы
 * при построении графиков.
 */
export function appPlatformPlugin(): Types.EnrichmentPlugin {
  return {
    name: 'imgame-app-platform',
    type: 'enrichment',
    execute: async (event) => ({
      ...event,
      event_properties: {
        ...event.event_properties,
        [APP_PLATFORM_PROPERTY]: APP_PLATFORM_WEB,
      },
    }),
  };
}
